<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="HolidayDatesForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                HOLIDAY DATES
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            List Of Holiday Dates
                        </p>
                    </div>
                </div>
                <hr>
                <div class="row ">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>Session</mat-label>
                                    <mat-select required #select238 placeholder="Session" class="colorblack"
                                        formControlName="SnNo" [disabled]="isdisabled">
                                        <mat-select-filter *ngIf="select238.focused" [placeholder]="'Filter'"
                                            [displayMember]="'SnName'" [array]="sessionList"
                                            (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                        <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo" (click)="selectSessionID(item.SnNo)">
                                            {{item.SnName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="table-responsive min mt-4 " *ngIf="Table">
                        <div class="container">
                            <table class="table text-nowrap table-bordered text-left">
                                <thead>
                                    <tr>

                                        <th class="f600" text-center>
                                            From Date
                                        </th>
                                        <th class="f600" text-center>
                                            To Date
                                        </th>
                                        <th class="f600" text-center>
                                            Holiday Name
                                        </th>
                                        <th class="f600" text-center>
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody id="table_data" formArrayName="DateArray">
                                    <tr *ngFor="let date of getControls(); let last = last; let i = index"
                                        [formGroupName]="i">
                                        <td>
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Choose From Date</mat-label>
                                                <input class="color" matInput [matDatepicker]="picker"
                                                    placeholder=" Date" formControlName="FromDate" (dateChange)="datechange(i)">
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                                <mat-error class="margin_tp mrgtp"
                                                    *ngIf="date.controls.FromDate.touched && date.controls.FromDate.errors?.required">
                                                    Mandatory
                                                </mat-error>
                                                <mat-error class="margin_tp mrgtp"
                                                *ngIf="date.controls.FromDate.touched && date.controls.FromDate.errors?.dateError">
                                               Date Cannot Be Greater Than To Date
                                            </mat-error>
                                            <mat-error class="margin_tp mrgtp"
                                            *ngIf="date.controls.FromDate.touched && date.controls.FromDate.errors?.TodaydateError">
                                           Date Cannot Be Less Than Today's Date
                                        </mat-error>
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Choose To Date</mat-label>
                                                <input class="color" matInput [matDatepicker]="picker1"
                                                    placeholder=" Date" formControlName="ToDate" (dateChange)="datechange1(i)">
                                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                                <mat-datepicker #picker1></mat-datepicker>
                                                <mat-error class="margin_tp mrgtp"
                                                    *ngIf="date.controls.ToDate.touched && date.controls.ToDate.errors?.required">
                                                    Mandatory
                                                </mat-error>
                                            <mat-error class="margin_tp mrgtp"
                                            *ngIf="date.controls.ToDate.touched && date.controls.ToDate.errors?.dateError">
                                           Date Cannot Be Less Than From Date
                                        </mat-error>
                                        <!-- <mat-error class="margin_tp mrgtp"
                                            *ngIf="date.controls.ToDate.touched && date.controls.ToDate.errors?.TodaydateError">
                                           Date Cannot Be Less Than Today's Date
                                        </mat-error> -->
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <input class="color" matInput placeholder=" Holiday Name" formControlName="HolidayName" maxlength="50">
                                                <mat-error class="margin_tp mrgtp"
                                                *ngIf="date.controls.HolidayName.touched && date.controls.HolidayName.errors?.required">
                                                Mandatory
                                            </mat-error>
                                            <mat-error class="margin_tp mrgtp"
                                                *ngIf="date.controls.HolidayName.touched && date.controls.HolidayName.errors?.pattern">
                                                Invalid
                                            </mat-error>
                                            </mat-form-field>
                                        </td>
                                        <td class="text-center">
                                            <a *ngIf="last" class="btn-floating" title="AddNew"
                                                (click)="addNewRow2(i,date)">
                                                <i class="fa fa-plus"></i>
                                            </a>
                                            <a class="btn-floating" title="Remove" (click)="deleteRow(i)">
                                                <i class="fa fa-minus"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row col-sm-12">
                    <div class="col-sm-12">
                        <button id="Save" type="button"
                         class="btn btn-primary btn-icon-text floatright mt-1" (click)="submitFun1()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button id="Back" type="button" [mat-dialog-close]="true"
                            class="btn btn-primary btn-icon-text floatright mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>